var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5108",
    width: 44,
    height: 44,
    rx: 8,
    style: {
      fill: "#e7e9ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 109",
    d: "M-3239.049 5991.789a1.032 1.032 0 0 1-.711-.284l-4.859-4.613a1.021 1.021 0 0 1-.034-1.449 1.033 1.033 0 0 1 1.457-.034l4.135 3.925 8.368-8.248a1.032 1.032 0 0 1 1.457.007 1.02 1.02 0 0 1-.007 1.449l-9.08 8.949a1.03 1.03 0 0 1-.726.298z",
    transform: "translate(3258.938 -5964.789)",
    style: {
      fill: "#1fb04b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChecked);
export default __webpack_public_path__ + "static/media/icn_checked.8253898bf66b214db45d009850512394.svg";
export { ForwardRef as ReactComponent };